import { Component, EventEmitter, Input,Output, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() totalItems: number = 0; // Total items for pagination
  @Input() pageSize: number = 10; // Items per page
  @Input() currentPage: number = 1;
  
  @Output() pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  
  @ViewChild(MatPaginator) paginator: MatPaginator;

  pageSizeOptions: number[] = [2, 5, 10, 25, 100];

  constructor() { }

  ngOnInit(): void {
  }

  // onPageChange(event: PageEvent): void {
  //   this.pageChange.emit(event);
  // }

  // @Input() length = 0; // Total number of items
  // @Input() pageSize = 10; // Default page size
  // @Input() pageSizeOptions: number[] = [5, 10, 25, 100]; // Default page size options

  // @Output() pageChange = new EventEmitter<any>(); // Emit event for page change

  // constructor() {}

  // ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // Reset paginator when totalItems changes (happens during search)
    if (changes['totalItems'] && !changes['totalItems'].firstChange) {
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
    }
    if (changes['currentPage'] && !changes['currentPage'].firstChange) {
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage - 1;
      }
    }
  }

  onPageChange(event: PageEvent): void {

//  @Output() pageChange = new EventEmitter<any>(); // Event emitter for page change

  // onPageChange(event: any) {
  //   const pageIndex = event.pageIndex + 1; // API expects page starting from 1, MatPaginator uses 0
  //   const pageSize = event.pageSize;
  //   this.pageChange.emit({ pageIndex, pageSize }); // Emit the page index and size
  // }
    this.pageChange.emit(event);
  }
}